import { ErrorMessage, useField } from 'formik';
import { Form as SForm, Input, Label, Message, SemanticWIDTHS } from 'semantic-ui-react';
import { useRef } from 'react';
import { withMask } from 'use-mask-input';
import { useFormikSchemaContext } from './FormikWithSchema';

interface Props {
    name: string;
    label?: string;
    description?: string;
    placeholder?: string;
    isReadOnly?: boolean;
    disabled?: boolean;
    required?: boolean;
    mask?: "phone" | "swabId";
    maxLength?: number;
    type?: string;
    autoComplete?: string;
    width?: SemanticWIDTHS;
    // [key: string]: any;
}

const SemanticFormikInput: React.FC<Props> = ({ name, label, description, placeholder, isReadOnly, mask, ...props }) => {
    const [field, meta] = useField(name);
    const schema = useFormikSchemaContext();
    const isRequired = schema?.isFieldRequired(name);
    const label_ = label ?? schema?.schema?.fields?.[name]?.spec?.label;

    const showError = meta.touched && !!meta.error;

    const mask_ = mask == "phone" ? "99 9999-9999" : mask == "swabId" ? "9999999999999_AAAA" : null;

    // const inputRef = mask_ != null ? withMask(mask_, { insertMode: false, insertModeVisual: false }) : useRef();
    const inputRef = useRef<any>();

    return (
        <SForm.Field width={props.width} error={showError} required={props.required ?? isRequired} disabled={props.disabled || isReadOnly} >
            {label_ && <label htmlFor={name}>{label_}</label>}
            {isReadOnly ? (
                <span>{field.value}</span>
            ) : (
                <Input ref={inputRef} error={showError} name={name} placeholder={placeholder} {...field} {...props} />
            )}
            {description && <div style={{ color: 'rgb(153, 153, 153)', fontSize: '0.8em', marginTop: '0.25em' }}>{description}</div>}
            {showError && <Label basic color="red" pointing>{meta.error}</Label>}
        </SForm.Field>
    );
};

export default SemanticFormikInput;

